import React from 'react';
import './About.css';

const About: React.FC = () => {
  return (
    <section className="about">
      <div className="about-container">
        <h1 className="section-title">About Me</h1>
        <div className="about-content">
          <div className="about-text">
            <p>
              I'm a dedicated software developer with a passion for building innovative solutions
              that make a difference. With a strong foundation in modern web technologies,
              I enjoy tackling complex problems and turning ideas into reality.
            </p>
            <p>
              My journey in software development has been driven by curiosity and a desire
              to continuously learn and grow. I believe in writing clean, maintainable code
              and collaborating with teams to deliver exceptional results.
            </p>
            <p>
              When I'm not coding, you can find me exploring new technologies, contributing
              to open-source projects, or sharing knowledge with the developer community.
            </p>
          </div>
          <div className="about-info">
            <div className="info-item">
              <strong>Location:</strong> Your City, Country
            </div>
            <div className="info-item">
              <strong>Email:</strong> your.email@example.com
            </div>
            <div className="info-item">
              <strong>Experience:</strong> X+ years
            </div>
            <div className="info-item">
              <strong>Status:</strong> Available for opportunities
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;